"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
interface HamburgerButtonProps {
  className?: string;
  isOpen: boolean;
}
export function HamburgerButton(t0) {
  const $ = _c(21);
  const {
    isOpen,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative flex h-10 w-10 items-center justify-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isOpen && "top-1/2 -translate-y-1/2 rotate-45";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("absolute top-0 left-0 block w-full border-foreground border-t-2 transition-all duration-300", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isOpen && "scale-x-0 opacity-0";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("absolute top-1/2 left-0 block w-full -translate-y-1/2 border-foreground border-t-2 transition-all duration-300", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <span className={t6} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = isOpen && "bottom-1/2 translate-y-1/2 -rotate-45";
  let t9;
  if ($[10] !== t8) {
    t9 = cn("absolute bottom-0 left-0 block w-full border-foreground border-t-2 transition-all duration-300", t8);
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <span className={t9} />;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t4 || $[16] !== t7) {
    t11 = <div className="relative h-4 w-6">{t4}{t7}{t10}</div>;
    $[14] = t10;
    $[15] = t4;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t1 || $[19] !== t11) {
    t12 = <div aria-hidden="true" className={t1}>{t11}</div>;
    $[18] = t1;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}